import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  selectorExamReports, getUserExamReports,
} from '../../app/slices/packageSlice'

const CourseResultReport = () => {
  // const classes = useStyle()
  const dispatch = useDispatch()
  const userExamReports = useSelector(selectorExamReports)
  const { userExamId } = useParams()

  useEffect(() => {
    dispatch(getUserExamReports(+userExamId))
  }, [+userExamId])

  console.log('userExamId', userExamId)
  console.log('userExamReports', userExamReports)

  // const data = { __html: userExamReports }

  return (
    // <div dangerouslySetInnerHTML={{ __html: userExamReports }} />
    <iframe
      style={{
        backgroundColor: '#fff',
        height: '78.5vh',
        border: 'none',
        borderRadius: '20px',
        width: '100%',
        boxSizing: 'content-box',
        overflowY: 'scroll',
        padding: '24px 0',
      }}
      srcDoc={userExamReports}
      id="result1"
      width="100%"
      height="710"
      title="exam reports"
    />
  )
}

export default CourseResultReport
